export const enum AuditState {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  WAITING = 'WAITING'
}

// 列表
export interface ITableType {
  id?: any;
  name?: string; // 姓名
  type?: any; // 类型 0 公司 1部门
  username?: string; // 用户名
  password?: string;
  phone?: string; // 电话号码
  fyDepartment?: any; // 公司
  departmentId?: any; // 部门id
  flag?: any; // 状态
  idCard?: string;
  bankCard?: string;
}

export const defaultValue: Readonly<ITableType> = {
  flag: 0
};

// 搜索表单
export interface ISearchForm {
  name?: string;
  phone?: string;
  username?: string;
  departmentId?: number;
  type?: number;
  idCard?: string;
}

export const defaultSearchForm: ISearchForm = {
  name: '',
  phone: ''
};
